const key = Symbol();
const ButtonColor = Object.freeze({
    RED: "RED",
    GREY: "GREY",
});
const supportedColors = [ButtonColor.RED, ButtonColor.GREY];
export { key, supportedColors, ButtonColor };
